/**
 * Email Signup Block Component
 *
 * Keeps your existing integrated button padding behavior.
 */
class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    this.lastButtonWidth = 0;
    this.observer = undefined;

    this.adjustInputPadding = this.adjustInputPadding.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    this.input = this.querySelector('.email-signup__input');
    this.inputGroup = this.querySelector('.email-signup__input-group');

    var isTextButton =
      this.button && this.button.classList.contains('email-signup__button--text');

    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.adjustInputPadding();

      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(() => {
          this.adjustInputPadding();
        });
        this.observer.observe(this.button);
      }

      if ('fonts' in document && document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          this.adjustInputPadding();
        });
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  adjustInputPadding() {
    if (!this.button || !this.inputGroup) return;

    var buttonWidth = this.button.offsetWidth;

    if (buttonWidth !== this.lastButtonWidth) {
      this.lastButtonWidth = buttonWidth;
      this.inputGroup.style.setProperty('--button-actual-width', buttonWidth + 'px');
    }
  }
}

if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}

/**
 * Bot Detection via User Agent
 */
function isBotUserAgent() {
  var userAgent = (navigator.userAgent || '').toLowerCase();
  
  // Common bot/crawler user agent patterns
  var botPatterns = [
    'bot',
    'crawl',
    'spider',
    'slurp',
    'mediapartners',
    'googlebot',
    'bingbot',
    'yandex',
    'baidu',
    'duckduck',
    'facebookexternalhit',
    'facebot',
    'ia_archiver',
    'semrush',
    'ahref',
    'mj12bot',
    'dotbot',
    'rogerbot',
    'screaming frog'
  ];

  for (var i = 0; i < botPatterns.length; i++) {
    if (userAgent.indexOf(botPatterns[i]) !== -1) {
      console.warn('[Bot Detection] Bot user agent detected:', botPatterns[i]);
      return true;
    }
  }

  return false;
}

document.addEventListener(
  'submit',
  function (event) {
    var form = event.target;

    // Match your markup: data-email-signup-form="true"
    if (!form || !form.matches || !form.matches('[data-email-signup-form]')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var messageEl = form.querySelector('[data-email-signup-message]');
    var emailInput = form.querySelector('input[type="email"]');

    // Simple helper to show the same validation error
    function showValidationError() {
      if (messageEl) {
        messageEl.textContent = 'Please enter a valid email address.';
        messageEl.classList.remove('email-signup__message--success');
        messageEl.classList.add('email-signup__message--error');
      }
    }
    // Remove error message when user types
    if (emailInput) {
      emailInput.addEventListener('input', function() {
        if (messageEl) {
          if (messageEl.classList.contains('email-signup__message--error') || messageEl.classList.contains('email-signup__message--success')) {
            messageEl.textContent = '';
            messageEl.classList.remove('email-signup__message--error');
            messageEl.classList.remove('email-signup__message--success');
          }
        }
      });
    }

    // 1) Empty email
    if (!emailInput || !emailInput.value) {
      showValidationError();
      return;
    }

    // 2) Pattern check (basic, but covers normal email formats)
    // - Allows letters, numbers, dots, underscores, dashes, and plus in local part
    // - Requires an '@' and a domain with at least one dot and 2+ letter TLD
    var emailValue = emailInput.value.trim();
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    if (!emailPattern.test(emailValue)) {
      showValidationError();
      return;
    }

    // Check for bot user agent
    if (isBotUserAgent()) {
      // Block bots with error message
      if (messageEl) {
        messageEl.textContent = 'Something went wrong. Please try again.';
        messageEl.classList.remove('email-signup__message--success');
        messageEl.classList.add('email-signup__message--error');
      }
      return;
    }

    var formData = new FormData(form);

    fetch(form.action, {
      method: form.method || 'POST',
      body: formData,
      redirect: 'manual'
    })
      .then(function (response) {
        // Check for error status codes (400 and above)
        if (response.status >= 400) {
          if (messageEl) {
            messageEl.textContent = 'Something went wrong. Please try again.';
            messageEl.classList.remove('email-signup__message--success');
            messageEl.classList.add('email-signup__message--error');
          }
          return;
        }

        // Success response
        if (messageEl) {
          messageEl.textContent = 'You are successfully signed up to receive emails. Use WELCOME15 for 15% off';
          messageEl.classList.remove('email-signup__message--error');
          messageEl.classList.add('email-signup__message--success');
        }
        if (emailInput) {
          emailInput.classList.add('email-success-input');
        }
      })
      .catch(function (error) {
        console.error('[email-signup] fetch error', error);
        if (messageEl) {
          messageEl.textContent = 'Something went wrong. Please try again.';
          messageEl.classList.remove('email-signup__message--success');
          messageEl.classList.add('email-signup__message--error');
        }
      });
  },
  true
);